import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardOrderRequestRoutes = [
	{
		key: "reward-order-request-dashboard",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order-requests/dashboard`,
		component: React.lazy(() => import("views/reward-views/order-requests/pages/OrderRequestDashboard")),
	},
	{
		key: "reward-order-request-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order-requests/list`,
		component: React.lazy(() => import("views/reward-views/order-requests/pages/OrderRequestList")),
	},
	{
		key: "reward-order-request-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order-requests/new`,
		component: React.lazy(() => import("views/reward-views/order-requests/pages/OrderRequestCreate")),
	},
	{
		key: "reward-order-request-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order-requests/detail/:id`,
		component: React.lazy(() => import("views/reward-views/order-requests/pages/OrderRequestDetail")),
	},
	{
		key: "reward-order-request-approval-queue",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order-requests/approval-queue`,
		component: React.lazy(() => import("views/reward-views/order-requests/pages/OrderRequestApprovalQueue")),
	},
	{
		key: "reward-order-request-config",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order-requests/config`,
		component: React.lazy(() => import("views/reward-views/order-requests/pages/OrderRequestConfig")),
	},
	{
		key: "reward-order-request-override-management",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order-requests/overrides`,
		component: React.lazy(() => import("views/reward-views/order-requests/pages/OverrideManagement")),
	},
];

